import { render, staticRenderFns } from "./TContent.vue?vue&type=template&id=1d578af5&scoped=true"
import script from "./TContent.vue?vue&type=script&lang=js"
export * from "./TContent.vue?vue&type=script&lang=js"
import style0 from "./TContent.vue?vue&type=style&index=0&id=1d578af5&prod&lang=scss&scoped=true"
import style1 from "./TContent.vue?vue&type=style&index=1&id=1d578af5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d578af5",
  null
  
)

export default component.exports